module.exports = __webpack_public_path__ + "img/yonder-logo-y-white.b405865e.svg";